"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCreateWebhookDto = instanceOfCreateWebhookDto;
exports.CreateWebhookDtoFromJSON = CreateWebhookDtoFromJSON;
exports.CreateWebhookDtoFromJSONTyped = CreateWebhookDtoFromJSONTyped;
exports.CreateWebhookDtoToJSON = CreateWebhookDtoToJSON;
exports.CreateWebhookDtoToJSONTyped = CreateWebhookDtoToJSONTyped;
/**
 * Check if a given object implements the CreateWebhookDto interface.
 */
function instanceOfCreateWebhookDto(value) {
    if (!('url' in value) || value['url'] === undefined)
        return false;
    if (!('events' in value) || value['events'] === undefined)
        return false;
    return true;
}
function CreateWebhookDtoFromJSON(json) {
    return CreateWebhookDtoFromJSONTyped(json, false);
}
function CreateWebhookDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'url': json['url'],
        'events': json['events'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}
function CreateWebhookDtoToJSON(json) {
    return CreateWebhookDtoToJSONTyped(json, false);
}
function CreateWebhookDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'url': value['url'],
        'events': value['events'],
        'description': value['description'],
    };
}
